export default function QuestionSubject() {
	return <div>hello</div>;
}
